<template>
    <div class="h-screen w-screen flex flex-col overflow-auto">
        <div class="flex mt-8">
            <h2 class="text-primary mx-auto my-auto text-xl md:text-5xl">Fotos del Carrusel</h2>
        </div>
        <form class="w-full max-w-lg p-2 mx-auto mt-2">
            <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full mb-2 px-3 md:w-2/3 md:mb-0 md:my-2">
                    <label class="block uppercase tracking-wide text-xs font-bold mb-2" for="grid-zip">
                        Nueva
                    </label>
                    <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-zip" type="text" placeholder="Nombre" v-model="nombre">
                    <p class="text-xs italic">Relacion de Aspecto 4:3. Resolucion 1200x900 px</p>
                </div>
                <div class="justify-center w-full flex md:w-1/3 md:my-6 p-1 md:justify-end">
                    <input type="file" style="display: none" ref="fileInput" accept="image/*" @change="onFilePicked">
                    <button class="shadow bg-primary hover:bg-purple-400 focus:shadow-outline focus:outline-none text-secondary font-bold py-2 px-4 rounded mt-2" type="button" @click="onPickFile">
                        <div class="flex">
                            Foto <span class="material-icons text-secondary mx-1">attachment</span>
                        </div>
                    </button>
                    <button class="shadow mx-1 bg-primary hover:bg-purple-400 focus:shadow-outline focus:outline-none text-secondary font-bold py-2 px-4 rounded mt-2" type="button" @click="uploadPhoto">Subir</button>
                </div>
                <div class="w-full items-center justify-center flex">
                    <img :src="imageUrl" style="max-height: 6rem;" class="m-2">
                </div>
                <div class="flex mx-auto mt-4 horline w-full mb-2">
                    <h2 class="text-primary mx-auto my-auto text-xl md:text-2xl">Listado de fotos subidas</h2>
                </div>
                <div class="w-full my-2 px-3 md:w-full md:mb-0 md:my-0">
                    <div class="flex flex-row my-2 w-full  justify-between" v-for="(foto, n) in fotos" :key="n">
                        <div class="mx-2 my-auto flex" style="max-height: 10rem;">
                            <img class="my-auto rounded-lg" :src="foto.link" style="max-height: 10rem;">
                        </div>
                        <p class="text-sm truncate my-auto"> <strong>{{foto.name}}</strong> {{foto.link}}</p>
                        <button type="button" class="my-auto mx-4 flex" @click="deleteFoto(foto.id)">
                            <span class="material-icons text-sm my-auto text-xl" style="color: #f56565">delete</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <CardModal :showing="exampleModalShowing" v-on:close="exampleModalShowing = false">
            <div>
                <h2 class="w-full text-center text-lg md:text-2xl"> Eliminar esta foto?</h2>
                <div class="w-full justify-center items-center flex">
                    <button class="shadow mx-1 focus:shadow-outline focus:outline-none text-secondary font-bold py-2 px-4 rounded mt-2" type="button" @click="exampleModalShowing = false; id=null;" style="background: #f56565">Cancelar</button>
                    <button class="shadow mx-1 bg-primary hover:bg-purple-400 focus:shadow-outline focus:outline-none text-secondary font-bold py-2 px-4 rounded mt-2" type="button" @click=" delFoto(id); exampleModalShowing = false; id = null; ">Eliminar</button>
                </div>
            </div>
        </CardModal>
    </div>
</template>
<script>
import CardModal from '@/components/shared/CardModal.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
    components: {
        CardModal
    },
    data() {
        return {
            exampleModalShowing: false,
            nombre: '',
            id: '',
            image: null,
            imageUrl: '',
        }
    },
    methods: {
        ...mapActions(['newFoto', 'delFoto']),
        onPickFile() {
            this.$refs.fileInput.click()
        },
        onFilePicked(event) {
            const files = event.target.files
            let filename = files[0].name
            if (filename.lastIndexOf('.') <= 0) {
                return alert('Please add a valid file!')
            }
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () => {
                this.imageUrl = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this.image = files[0]
        },
        uploadPhoto() {
            if (!this.image) {
                this.$store.commit('showMessage', { content: 'No ha adjuntado ninguna imagen de producto!', color: 'error' })
                return
            }
            const foto = {
                nombre: this.nombre,
                image: this.image,
            }
            this.newFoto(foto)
            this.nombre = '',
            this.image = null,
            this.imageUrl = ''
        },
        deleteFoto(val) {
            this.exampleModalShowing = true
            this.id = val
            //this.delFoto(val)
        }
    },
    computed: {
        ...mapGetters(['getCarousel']),
        fotos() {
            return this.getCarousel
        }
    }
}
</script>
<style scoped>
.horline {
    border-bottom: 2px solid #000;
}
</style>